import VueRouter from "vue-router";
import Vue from "vue";
import Home from "@/Views/Home.vue";
import Signup from "@/Views/Auth/Signup.vue";
import Timeline from "@/Views/Timeline.vue";
import Login from "@/Views/Auth/Login.vue";
import accessdenied from "@/Views/accessdenied.vue";
import Temppassword from "@/Views/Auth/Temppassword.vue";
import Forgotpwd from "@/Views/Auth/Forgotpwd.vue";
// import Forgotpassword from "@/Views/Auth/forgotPassword.vue";
// import Navbar from "@/components/Navbar.vue";
// import changePassword from "@/Views/Auth/changePassword.vue";
import OnBoard from "@/Views/OnBoarding/OnBoard.vue";
import RequestCard from "@/Views/Card/RequestCard.vue";
import Subscription from "@/Views/Card/Subscription.vue";
import Dashboard from "@/Views/Dashboard/Dashboard.vue";

import CreateCorp from "@/Views/Referrer/CreateCorp.vue";
import RefCommission from "@/Views/Referrer/RefCommission.vue";

import ViewCorp from "@/Views/Referrer/ViewCorp.vue";
import ReferrerDashboard from "@/Views/Referrer/ReferrerDashboard.vue";

import CardStatus from "@/Views/Card/CardStatus.vue";
import users from "@/Views/users/users.vue";
import corporatefunds from "@/Views/Funds/corporatefunds.vue";
import cardfunds from "@/Views/Funds/cardfunds.vue";
import transactioncorp from "@/Views/Funds/transactioncorp.vue";

import approvefunds from "@/Views/Funds/approvefunds.vue";
import CardBalance from "@/Views/Funds/CorpFund.vue";
import Unload from "@/Views/Funds/Unload.vue";

import upload from "@/Views/Funds/upload.vue";
import Department from "@/Views/Masters/Department.vue";
import Budgets from "@/Views/Budget/Departmentfile.vue";
import Budget from "@/Views/Budget/Budget.vue";
import BudgetDuration from "@/Views/Masters/BudgetDuration.vue";
import Employees from "@/Views/Employees/Employees.vue";
import AppTrail from "@/Views/Employees/AppTrail.vue";

// import Basicview from "@/Views/Employees/Basicview.vue"
import location from "@/Views/Masters/location.vue";
import ExpenseMasters from "@/Views/Masters/ExpenseMasters.vue";
import FundApproval from "@/Views/Funds/FundApproval.vue";
import CategoryExpense from "@/Views/ExpseMgmt/CategoryExpense.vue";
import UserTypeCreation from "@/Views/ExpseMgmt/UserTypeCreation.vue";
import PartialApprove from "@/Views/ExpseMgmt/HalfwayMAin.vue";
import Recoverytab from "@/Views/ExpseMgmt/Recoverytab.vue";
import Approval from "@/Views/ExpseMgmt/ApprovalExpense.vue";
import Admin from "@/Views/Admin/Admin.vue";
import Billingreport from "@/Views/Billing/billingreport.vue";
import CategoryMasters from "@/Views/Masters/CategoryMasters.vue";
// import CardMaster from "@/Views/Masters/CardMaster.vue"
import CardTypeMaster from "@/Views/Masters/CardTypeMaster.vue";
import CreateInvoice from "@/Views/InvoiceFile/CreateInvoice.vue";
import UploadInvoice from "@/Views/InvoiceFile/UploadInvoice.vue";
import Invoicepayment from "@/Views/InvoiceFile/Invoicepayment.vue";
import ApprovalInvoice from "@/Views/InvoiceFile/ApprovalInvoice.vue";
import ExpenseClassificatn from "@/Views/InvoiceFile/ExpenseClassificatn.vue";
import ContactUs from "@/Views/ContactUs.vue";
import Transactions from "@/Views/Transactions.vue";
import Allcharts from "@/components/Charts/Allcharts.vue";
import next from "@/components/Charts/newchar.vue";
import postpayment from "@/Views/Payments/postpayment.vue";
// import users from "@/Views/users/users.vue"

// import cardeghl from "@/Views/Payments/cardeghl.html"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },

  {
    component: Home,
    path: "/Home",
    children: [
      {
        path: "/accessdenied",
        name: "accessdenied",
        component: accessdenied,
      },
      {
        path: "/Allcharts",
        name: "Allcharts",
        component: Allcharts,
      },
      {
        path: "/next",
        name: "next",
        component: next,
      },

      {
        path: "/Createvendor",
        name: "CreateInvoice",
        component: CreateInvoice,
      },
      {
        path: "/UploadInvoice",
        name: "UploadInvoice",
        component: UploadInvoice,
      },
      {
        path: "/ContactUs",
        name: "ContactUs",
        component: ContactUs,
      },
      {
        path: "/Transactions",
        name: "Transactions",
        component: Transactions,
      },

      {
        path: "/ApprovalInvoice",
        name: "ApprovalInvoice",
        component: ApprovalInvoice,
      },
      {
        path: "/InvoiceExpenseClassificatn",
        name: "ExpenseClassificatn",
        component: ExpenseClassificatn,
      },
      {
        path: "/Invoicepayment",
        name: "Invoicepayment",
        component: Invoicepayment,
      },
      {
        path: "/RequestCard",
        name: "Request Card",
        component: RequestCard,
      },
      {
        path: "/ExpenseMgmtPartialApprove",
        name: "PartialApprove",
        component: PartialApprove,
      },
      {
        path: "/Subscription",
        name: "Subscription",
        component: Subscription,
      },

      {
        path: "/location",
        name: "location",
        component: location,
      },

      {
        path: "/ExpenseMgmtrules",
        name: "CategoryExpense",
        component: CategoryExpense,
      },
      {
        path: "/ExpenseCategory",
        name: "CategoryMasters",
        component: CategoryMasters,
      },
      // {
      //   path: "/CardtypeMaster",
      //   name: "CardMaster",
      //   component: CardMaster,
      // },
      {
        path: "/CardTypeMaster",
        name: "CardTypeMaster",
        component: CardTypeMaster,
      },
      {
        path: "/ExpenseRuleMasters",
        name: "ExpenseMasters",
        component: ExpenseMasters,
      },
      {
        path: "/FundApproval",
        name: "FundApproval",
        component: FundApproval,
      },
      {
        path: "/ExpenseMgmtUserTypeCreation",
        name: "UserTypeCreation",
        component: UserTypeCreation,
      },
      {
        path: "/ApprovalExpense",
        name: "Approval",
        component: Approval,
      },

      {
        path: "/Recoverytab",
        name: "Recoverytab",
        component: Recoverytab,
      },

      {
        path: "/Employees",
        name: "Employees",
        component: Employees,
      },
      {
        path: "/AppTrail",
        name: "AppTrail",
        component: AppTrail,
      },
      {
        path: "/corporatetransaction",
        name: "transactioncorp",
        component: transactioncorp,
      },
      {
        path: "/BudgetDuration",
        name: "BudgetDuration",
        component: BudgetDuration,
      },
      {
        path: "/approvefunds",
        name: "approvefunds",
        component: approvefunds,
      },
      {
        path: "/AdminAccess",
        name: "Admin",
        component: Admin,
      },
      {
        path: "/billingreport",
        name: "billingreport",
        component: Billingreport,
      },
      {
        path: "/DepartmentMasters",
        name: "Department",
        component: Department,
      },
      {
        path: "/Budget",
        name: "Budget",
        component: Budget,
      },
      {
        path: "/Budgets",
        name: "Budgets",
        component: Budgets,
      },
      {
        path: "/corporatefundrequest",
        name: "corporatefunds",
        component: corporatefunds,
      },
      {
        path: "/upload",
        name: "upload ",
        component: upload,
      },
      {
        path: "/cardfundshistory",
        name: "cardfunds",
        component: cardfunds,
      },
      {
        path: "/CardBalance",
        name: "CardBalance",
        component: CardBalance,
      },
      {
        path: "/Unload",
        name: "Unload",
        component: Unload,
      },

      {
        path: "/cardstockmanagement",
        name: "users",
        component: users,
      },
      {
        path: "/CardStatus",
        name: "Card Status",
        component: CardStatus,
      },
      {
        path: "/Dashboard",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: "/CreateCorp",
        name: "CreateCorp",
        component: CreateCorp,
      },
      {
        path: "/RefCommission",
        name: "RefCommission",
        component: RefCommission,
      },
      {
        path: "/ViewCorp",
        name: "ViewCorp",
        component: ViewCorp,
      },
      {
        path: "/ReferrerDashboard",
        name: "ReferrerDashboard",
        component: ReferrerDashboard,
      },

      {
        path: "/Timeline",
        name: "Timeline",
        component: Timeline,
      },
      {
        path: "/postpayment",
        name: "postpayment",
        component: postpayment,
      },
    ],
  },
  {
    path: "/Signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/OnBoard",
    name: "OnBoard",
    component: OnBoard,
  },
  {
    path: "/Forgotpwd",
    name: "Forgotpwd",
    component: Forgotpwd,
  },
  {
    path: "/Temppassword",
    name: "Temppassword",
    component: Temppassword,
  },
  // {
  //   path: "/verifyme",
  //   name: "verifyme",
  //   component: verifyme,
  // },

  // {
  //   path: "/ForgotPassword",
  //   name: "ForgotPassword",
  //   component: Forgotpassword,
  // },
  // {
  //   path: "/changePassword",
  //   name: "change Password",
  //   component: changePassword,
  // },
];
const router = new VueRouter({
  // mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
